<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="debits"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :date="date"
      :sort="sort"
    ></filtered-data>
    <div class="container-fluid d-flex align-items-center my-1">
      <filter-range-date v-model="date" class="ml-auto mr-2" style="max-width: 26em;"/>
    </div>
    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @sort-change="sortChange"
        show-summary
      >
        <table-column-date prop="created_at" align="center" sortable="custom" label="Дата и время"/>
        <table-column-number prop="params.count" align="center" sortable="custom" label="Количество модемов"/>
        <table-column-number prop="params.cost" align="center" sortable="custom" label="Стоимость за 1 модем"/>
        <table-column-number prop="value" align="center" sortable="custom" label="Общая стоимость"/>
        <el-table-column prop="subscription" align="center" sortable="custom" label="Тариф">
          <template slot-scope="{row}">
            {{row.tariff}}
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data () {
      return {
        loading: false,
        hasMore: true,
        data: {},
        date: {
          min: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          max: moment().format('YYYY-MM-DD'),
        },
        sort: null,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'

          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/payments/history/charges.vue